import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2c86e14e"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c86e14e')) {
      api.createRecord('2c86e14e', component.options)
    } else {
      api.reload('2c86e14e', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=2c86e14e", function () {
      api.rerender('2c86e14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Login/Login.vue"
export default component.exports